import { render, staticRenderFns } from "./LineOfBusiness.vue?vue&type=template&id=1563abf7"
import script from "./LineOfBusiness.vue?vue&type=script&lang=ts"
export * from "./LineOfBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports